import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import {
  Link,
  AndrewBeharSignature
} from '../'
import Styles from './PlanScorecardCompanyLetter.css'


@CSSModules(Styles, {allowMultiple: true})
export default class ComcastCompanyLetter extends Component {
  static propTypes = {
    differentPage: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      differentPage: this.props.differentPage || false
    }
  }

  render() {
    const { differentPage } = this.state
    //
    return (
      <blockquote styleName='company-letter-blockquote'>
        <p><b>July 27, 2021</b></p>

        <p><b>Brian L. Roberts<br/>
        President and Chief Executive Officer<br/>
        Comcast<br/>
        1701 JFK Boulevard<br/>
        Philadelphia, PA 19103</b></p>

        <p><b>Re: Comcast employee retirement plan sustainability scorecard</b></p>

        <p>Dear Mr. Roberts,</p>

        <p>Comcast is known to be a leader on climate change, highlighted by its aspirational goals of zero emissions, zero waste, and 100% renewable energy. However, your company retirement plan directly contradicts all of this hard work on your operations.</p>

        <p>I am writing to inform you about the upcoming release of As You Sow’s corporate retirement plan sustainability scorecard initiative and would like to extend an offer to meet and discuss our work. Below is a brief overview of the scorecard, where Comcast is among the first companies rated. </p>

        <p>The corporate retirement plan sustainability scorecard initiative will empower the millions of U.S. employees holding trillions in retirement assets to invest their retirement savings sustainably. Many employees across the nation are unaware that their retirement plan investments are invested in climate change, prisons, weapons, and companies that score poorly on gender equality.</p>

        <p>We are using our <Link to={config.links.aysinvest} title='Invest Your Values - As You Sow' xstrong>expertise in mutual fund sustainability analysis</Link> and our extensive database of ESG-screened companies to rate corporations’ retirement plan investment options.  Those investment options have been graded across seven major environmental and social issues, including deforestation, climate, and the prison industrial complex.</p>

        {
          differentPage ?
            (
              <p><Link to={config.routes.plans + '/comcast'} title='Comcast retirement plan sustainability scorecard' xstrong>The scorecard results for Comcast’s retirement plan</Link> directly contradict Comcast’s leadership on climate change and other issues.</p>
            ) :
            (
              <p><ScrollLink to='scores' spy title='Comcast retirement plan sustainability scorecard' smooth offset={-50} duration={500}><span styleName='scroll-link'>The scorecard results for Comcast’s retirement plan</span></ScrollLink> directly contradict Comcast’s leadership on climate change and other issues.</p>

            )
        }

        <p>Since 1992, As You Sow has had great success helping companies to adopt beneficial policies and practices on a range of environmental, social, and governance issues. The time is ripe for Comcast to show its leadership by aligning its sustainability goals holistically across both operations and its retirement plan. We commend Comcast in its efforts to build a sustainable business for all stakeholders and the planet, including ambitious climate goals and implementing them with action.</p>

        <p>While Comcast has made significant efforts in addressing climate change and social issues across its operations, data obtained from Form 5500 SEC filings, along with information published by the Company for retirement plan participants, demonstrates a lack of alignment between the Company’s sustainability goals and its current retirement investment options offered through the Company’s employee retirement plan. Although Comcast has establisheded its commitment to reducing its climate impact, the Company’s employee retirement plan currently has no ESG options available for employees who want to invest sustainably. Despite stated social goals, the Comcast employee retirement plan is currently investing in companies profiting from the prison industrial complex.</p>

        <p>Critically, the default plan option is not invested sustainably. Over 50% of assets invested in the Comcast employee retirement plan are invested in the default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.</p>

        <p>Most employees assume the default option in their retirement plan is a safe choice. But if climate risk and other sustainability issues are not incorporated into the portfolio composition by the fund manager, employees could be exposed to financial risks from unsustainable investments. Asset managers recognize they have a fiduciary duty to mitigate the systemic risks of climate change: in 2020, <Link to={'https://www.blackrock.com/corporate/investor-relations/2020-blackrock-client-letter'} title='Sustainability as BlackRock’s New Standard for Investing' xstrong>major asset manager BlackRock announced</Link> "We intend to make sustainable funds the standard."</p>

        {
          differentPage ?
            (
              <p>Comcast’s retirement plan is rated Poor on five of seven issue areas. The full results <Link to={config.routes.plans + '/comcast'} title='Comcast retirement plan sustainability scorecard' xstrong>can be found here.</Link></p>
            ) :
            (
              <p>Comcast’s retirement plan is rated Poor on five of seven issue areas. The full results <ScrollLink to='scores' spy title='Comcast retirement plan sustainability scorecard' smooth offset={-50} duration={500}><span styleName='scroll-link'>can be found here.</span></ScrollLink></p>
            )
        }

        <p>Comcast has the unique opportunity to become an industry leader and help shift billions of dollars away from climate destruction and into companies that define the new economic paradigm in a safe, just, and sustainable world. We would appreciate the opportunity to meet with you and show you the details of our scorecard.</p>

        <p>Thank you for your time and consideration, and we look forward to hearing back from you. </p>

        <AndrewBeharSignature />

      </blockquote>
    )
  }
}
